'use client';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { LocationsLandingProps } from './types';

const LocationsMap = dynamic(() => import('./LocationsMap'), {
  ssr: false,
  loading: () => (
    <div className='w-full max-w-5xl mx-auto h-[700px] flex items-center justify-center bg-gray-50 rounded-xl animate-pulse'>
      <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center'>
        <p className='text-gray-400 font-medium'>Loading Map...</p>
      </div>
    </div>
  ),
});

function formatBrandName(brandName: string): string {
  return brandName
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function LocationsLanding({ locationsByState, mapConfig }: LocationsLandingProps) {
  const brandName = formatBrandName(mapConfig.brandName);

  useEffect(() => {
    // Force scroll to top on mount to counteract next/dynamic ssr: false layout shifts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='w-full min-h-[60vh] bg-white pt-16 flex flex-col items-center'>
      <div className='text-center px-4 z-10 relative'>
        <h1 className='text-[28px] md:text-[42px] font-bold mb-6'>
          <span className='text-primary-500'>Find a {brandName} Pro</span>
          <span className='text-primary-500 font-light'> in Your Area</span>
        </h1>
      </div>

      <LocationsMap
        locationsByState={locationsByState}
        mapView={mapConfig.mapView}
        allowedStateShorts={mapConfig.allowedStateShorts}
      />
    </div>
  );
}
